<template>
  <div class="down" @click="data.tutorial = !data.tutorial">
    <span>展开</span><van-icon name="arrow-down" />
  </div>
  <div
    class="copywriting"
    ref="copywriting"
    :class="store.isSafari ? 'isSafariClass' : ''"
  >
    <van-pull-refresh
      v-model="data.isLoading"
      :head-height="40"
      @refresh="data.onRefresh"
    >
      <template #pulling>
        <div class="refreshText">下拉加载历史记录(仅支持7天内)</div>
      </template>
      <template #loosing>
        <div class="refreshText">下拉加载历史记录(仅支持7天内)</div>
      </template>
      <template #success>
        <div class="refreshText">{{ data.successText }}</div>
      </template>
      <div class="main">
        <div>
          <div
            class="center"
            v-for="(item, index) in data.writingList"
            :key="index"
          >
            <div :class="data.itemType(item) ? 'userItem' : 'item'">
              <div class="active">
                <img
                  v-if="data.itemType(item)"
                  :src="data.userInfo.avatar"
                  alt=""
                />
                <img v-else :src="data.appInfo.app_dialogue_avatar" alt="" />
              </div>
              <div v-if="item.type === 'User'">
                <div class="text">
                  {{ item.text }}
                </div>
                <div class="userEditBtn">
                  <span
                    class="editBtn"
                    v-if="item.type === 'User' && !item.flag"
                    @click="data.edit(item.text)"
                  >
                    <img src="@/assets/editText.png" alt="" />
                    修改
                  </span>
                </div>
              </div>
              <div v-else>
                <div
                  class="text"
                  v-if="item.text !== '....'"
                  v-html="item.text"
                ></div>
                <div class="text stop" v-else>
                  正在努力创作中，请耐心等候
                  <div class="dotContainer">
                    <div class="dot"></div>
                    <div class="dot"></div>
                    <div class="dot"></div>
                  </div>
                </div>
                <img
                  v-if="!item.flag"
                  class="copyBtn"
                  src="@/assets/copy.png"
                  alt=""
                  @click="data.copy()"
                  :data-clipboard-text="item.copyText"
                />
              </div>
            </div>
            <div class="btnList" v-if="item.type === 'AI' && !item.flag">
              <span class="editBtn" @click="data.laud">
                <img :src="data.laudFlage ? resLaud : laud" alt="" />
                点赞
              </span>
              <span class="editBtn" @click="data.shares">
                <img src="@/assets/share.png" alt="" />
                分享
              </span>
              <span
                class="editBtn copyBtn"
                @click="data.copy(item.copyText)"
                :data-clipboard-text="item.copyText"
              >
                <img src="@/assets/copy.png" alt="" />
                复制
              </span>
              <span
                class="editBtn"
                @click="
                  data.edit(data.writingList[data.writingList.length - 2].text)
                "
              >
                <img src="@/assets/renovate.png" alt="" />
                重新创作
              </span>
            </div>
            <span
              class="laud"
              v-if="
                item.type === 'AI' &&
                data.btnFlag &&
                item.flag &&
                data.localStorageFlage
              "
              >对创作成果首次点赞或分享可得5花瓣/次</span
            >
          </div>
        </div>
      </div>
    </van-pull-refresh>
  </div>
  <van-popup
    class="tutorial"
    v-model:show="data.tutorial"
    position="top"
    :overlay="false"
  >
    <div class="item">
      <div class="active">
        <img
          v-if="data.userInfo && data.userInfo.avatar"
          :src="data.userInfo.avatar"
          alt=""
        />
        <img v-else src="@/assets/userActive.png" alt="" />
      </div>
      <div class="text intro">
        {{ props.intro }}
      </div>
    </div>
    <div class="header" v-if="data.appInfo.scenario_case.data">
      <div class="title">场景案例</div>
      <div class="btn" @click="data.goNewPage">
        更多教程<img src="@/assets/right.png" alt="" />
      </div>
    </div>
    <div class="list">
      <div class="textSwiper">
        <div class="swiper-wrapper">
          <div
            class="swiper-slide"
            v-for="(item, index) in data.newArr"
            :key="index"
          >
            <div class="card">
              <div class="item userItem">
                <div class="active">
                  <img
                    v-if="data.userInfo && data.userInfo.avatar"
                    :src="data.userInfo.avatar"
                    alt=""
                  />
                  <img v-else src="@/assets/userActive.png" alt="" />
                </div>
                <div
                  class="text"
                  style="background: #8368fc"
                  v-html="item[0]"
                ></div>
              </div>
              <div class="item">
                <div class="active">
                  <img :src="data.appInfo.app_dialogue_avatar" alt="" />
                </div>
                <div
                  class="text"
                  style="background: #1d2234"
                  v-html="item[1]"
                ></div>
              </div>
            </div>
            <div class="bottom" @click="data.textClick(item[0])">
              填入下方试试<img src="@/assets/down.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="up" @click="data.tutorial = !data.tutorial">
      <span>收起</span><van-icon name="arrow-up" />
    </div>
  </van-popup>
  <van-popup class="sharesPopup" :show="data.sharesShow">
    <div class="shares">
      <div class="cavers" ref="shares">
        <div class="header">
          {{ data.appInfo.name }}
        </div>
        <div class="tip">
          {{ data.appInfo.desc }}
        </div>
        <div class="center">
          <div
            class="item"
            v-for="(item, index) in data.sharesList"
            :key="index"
          >
            <div class="sharesActive" v-if="index === 1">
              <img
                v-if="data.itemType(item)"
                src="@/assets/userActive.png"
                alt=""
              />
              <img v-else :src="data.appInfo.app_dialogue_avatar" alt="" />
            </div>
            <div
              class="sharesText"
              v-html="item.text"
              :class="index === 1 ? '' : 'mr-16'"
            />

            <div class="sharesActive" v-if="index === 0">
              <img
                v-if="data.itemType(item)"
                src="@/assets/userActive.png"
                alt=""
              />
              <img v-else src="@/assets/aiActive.png" alt="" />
            </div>
          </div>
        </div>
        <div class="qrcode">
          <div>
            <div class="title">花集AI</div>
            <div class="samll">让天下没有难用的AI</div>
          </div>
          <div class="code">
            <img :src="data.qrcode" alt="" />
          </div>
        </div>
      </div>
      <div class="bottom">
        <div @click="data.copy"         
        class="copyBtn"
        :data-clipboard-text="data.shareImgUrl">
          <img src="@/assets/imgInfolink.png" alt="" />复制链接
        </div>
        <div @click="data.saveImg" :style="data.sharsUrl ? '' : 'opacity:.8'">
          <img src="@/assets/saveIcon.png" alt="" />保存图片
        </div>
      </div>
      <div class="close" @click="data.sharesShow = false">
        <img src="@/assets/sharesCloes.png" alt="" />
      </div>
    </div>
  </van-popup>
  <div class="m-share" id="share"></div>
</template>

<script setup>
import {
  ref,
  reactive,
  toRefs,
  onBeforeMount,
  onMounted,
  watchEffect,
  computed,
  watch,
  nextTick,
} from "vue";
import { useCounterStore } from "@/store";
import { useRoute, useRouter } from "vue-router";
import { showNotify } from "vant";
import { AItext, historyDialogue, clickLike, Appshare } from "@/api/text";
import resLaud from "@/assets/resLaud.png";
import laud from "@/assets/laud.png";
import cross from "@/assets/cross.png";
import html2canvas from "html2canvas";
import share from "m-share";
import { userInfo } from "@/api/login";
import { showSuccessToast } from "vant";
import surres from "@/assets/surres.png";
import Swiper from "swiper";
import { getConfig, undateImg } from "@/api/img";
import ClipboardJS from "clipboard";
import { showConfirmDialog } from "vant";
import { showToast } from "vant";
import { getToken } from "@/ulits/auth";
import { teamCode } from "@/api/invite";
const { marked } = require("marked");
const QRCode = require("qrcode");
const emit = defineEmits(["editText", "clickText"]);
/**
 * 仓库
 */
const store = useCounterStore();
/**
 * 路由对象
 */
const route = useRoute();
/**
 * 路由实例
 */
const router = useRouter();
//console.log('1-开始创建组件-setup')
/**
 * 数据部分
 */
const data = reactive({});
data.shareImgUrl = ''
data.AntiShake = true;
const shares = ref(null);
data.activeIndex = 0;
data.goNewPage = () => {
  window.open("https://huajiwang.feishu.cn/wiki/BGN5wBnW9ibJ7GkiF6JctJQDnAf");
};
data.shareWx = () => {
  share.to("wx");
  if (data.AntiShake) {
    data.AntiShake = false;
    Appshare({ app_id: data.appInfo.id }).then((res) => {
      if (res.code === 200) {
        localStorage.setItem("laudFlae", false);
        data.AntiShake = true;
        data.laudFlage = true;
        showSuccessToast({
          message: res.message,
          icon: surres,
        });
      } else {
        data.AntiShake = true;
      }
    });
  }
};
data.saveImg = () => {
  if (data.sharsUrl) {
    let a = document.createElement("a");
    a.href = data.sharsUrl;
    a.download = "AI";
    a.click();
  } else {
    showToast("正在生成图片");
  }
};
data.writingList = [];
data.qrcode = "";
QRCode.toDataURL(location.href.split("#")[0]).then((res) => {
  data.qrcode = res;
});
data.localStorageFlage = localStorage.getItem("laudFlae") ? false : true;
data.userInfo = JSON.parse(localStorage.getItem("userInfo"));
data.innerHeightFlag = false;
data.btnFlag = false;
data.tutorial = false;
data.isLoading = false;
data.showPopover = true;
data.laudFlage = false;
data.num = 1;
data.newArr = [];
data.appInfo = JSON.parse(localStorage.getItem("appInfo"));
if (data.appInfo.scenario_case.type === "text") {
  // while (data.appInfo.scenario_case.data.length) {
  console.log(data.appInfo);
  data.newArr = data.appInfo.scenario_case.data;
  data.newArr.map((e, newArrIndex) => {
    e.map((item, eIndex) => {
      if (eIndex === 1) {
        data.newArr[newArrIndex][eIndex] = marked(item);
      }
    });
  });
}

data.editScenario_case = () => {
  if (data.appInfo.scenario_case.type === "text") {
    // while (data.appInfo.scenario_case.data.length) {
    data.newArr = data.appInfo.scenario_case.data;
    data.newArr.map((e, newArrIndex) => {
      e.map((item, eIndex) => {
        if (eIndex === 1) {
          data.newArr[newArrIndex][eIndex] = marked(item);
        }
      });
    });
  }
};

const copywriting = ref(null);
data.shares = () => {
  data.appInfo = JSON.parse(localStorage.getItem("appInfo"));
  teamCode().then((res) => {
    if (res.code === 200) {
      let params = new URL(document.location).searchParams;
      let param1 = params.get("id");
      data.shareImgUrl = param1
        ? location.href + "&invite_code=" + res.data.code
        : location.href +
          "?id=" +
          data.appInfo.id +
          "&invite_code=" +
          res.data.code;
      QRCode.toDataURL(data.shareImgUrl).then((res) => {
        data.qrcode = res;
        data.sharesList = [
          data.writingList[data.writingList.length - 2],
          data.writingList[data.writingList.length - 1],
        ];
        data.sharesShow = true;
        setTimeout(() => {
          html2canvas(shares.value, {
            allowTaint: true,
            useCORS: true,
          }).then((canvas) => {
            const sharsUrl = canvas.toDataURL("image/png");
            console.log(data.base64ToFile(sharsUrl, "newfile.png"));
            undateImg(data.base64ToFile(sharsUrl, "newfile.png")).then(
              (res) => {
                data.sharsUrl = res.url;
                if (/android/i.test(navigator.userAgent)) {
                  wx.onMenuShareAppMessage({
                    title: data.appInfo.name,
                    desc: data.appInfo.desc,
                    link: res.url,
                    imgUrl: res.url,
                  });
                }
                if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
                  wx.updateAppMessageShareData({
                    title: data.appInfo.name,
                    desc: data.appInfo.desc,
                    link: res.url,
                    imgUrl: res.url,
                  });
                }
              }
            );
          });
        });
      });
    }
  });
};

data.base64ToFile = (base64, fileName) => {
  const arr = base64.split(",");
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], fileName, { type: mime });
};

data.setScrollTo = () => {
  nextTick(() => {
    copywriting.value.scrollTop = copywriting.value.scrollHeight;
  });
};

data.hasLessThanTen = false;
data.successText = "加载完成";
data.onRefresh = () => {
  if (data.hasLessThanTen) {
    data.successText = "暂无更多数据";
    data.isLoading = false;
    return;
  }
  if (data.userInfo && getToken()) {
    data.getHistoryDialogue(10);
  } else {
    data.successText = "暂无更多数据";
    data.isLoading = false;
  }
};

data.getHistoryDialogue = (e) => {
  historyDialogue({
    app_id: data.appInfo.id,
    page: data.num,
    page_size: e,
  }).then((res) => {
    nextTick(() => {
      copywriting.value.scrollTop = copywriting.value.scrollHeight;
    });
    if (res.data.data.length != e) {
      data.hasLessThanTen = true;
    } else {
      if (e === 10) {
        data.num = data.num + 1;
      }
    }
    const user = res.data.data.filter((i) => {
      return i.message_type === 1;
    });
    const AI = res.data.data.filter((i) => {
      return i.message_type === 2;
    });
    if (e === 10 && data.writingList.length === 2) {
      if (data.writingList[0].id && data.writingList[1].id) {
        let userIndex = user.findIndex(
          (item) => item.id === data.writingList[0].id
        );
        let aiIndex = AI.findIndex(
          (item) => item.id === data.writingList[1].id
        );
        user.splice(userIndex, 1);
        AI.splice(aiIndex, 1);
      }
    }
    AI.forEach((e, index) => {
      data.writingList.unshift({
        text: marked(e.message),
        copyText: e.message,
        type: "AI",
        flag: false,
        id: e.id,
      });
      data.writingList.unshift({
        text: user[index].message,
        type: "User",
        flag: false,
        id: user[index].id,
      });
    });
    if (e === 2 && data.writingList.length === 0) {
      data.tutorial = true;
    }
    data.isLoading = false;
  });
};

const props = defineProps({
  intro: String,
  params: Object,
});

// data.again=()=>{
//   data.writingList[data.writingList.length-1].text = '....'
//   data.btnFlag = false
//   AItext({
//     app_id:data.appInfo.id,
//     content:props.text
//   }).then(res=>{
//     if (res.code === 200) {
//       let text = res.data.answer
//       let index = 0;
//       data.writingList[data.writingList.length-1].text = ''
//       data.time = setInterval(()=>{
//         data.writingList[data.writingList.length-1].text += text.charAt(index);
//         index++;
//         if (index >= text.length) {
//           data.btnFlag = true
//           clearInterval(data.time)
//         }
//         nextTick(()=>{
//           copywriting.value.scrollTop=9999999
//         })
//       },100)
//     }
//   })
// }

data.edit = (e) => {
  showConfirmDialog({
    title: "提示",
    message:
      "重新创作需要" +
      Number(data.appInfo.petal_price) +
      "花瓣,需要重新创作吗？",
  }).then(() => {
    emit("editText", e);
    data.btnFlag = false;
    clearInterval(data.time);
    clearTimeout(data.times);
  });
  // data.writingList = []
};
// 监听事件
watch([() => props.text], ([newText, newOtherProp]) => {});

data.AItextClear = (e) => {
  data.appInfo = JSON.parse(localStorage.getItem("appInfo"));
  data.laudFlage = false;
  data.btnFlag = false;
  if (e !== "") {
    data.writingList.push(
      {
        type: "User",
        text: e,
        flag: true,
      },
      {
        type: "AI",
        text: "....",
        flag: true,
      }
    );
    AItext({
      app_id: data.appInfo.id,
      content: e,
    }).then((res) => {
      const info = localStorage.getItem("userInfo");
      if (info) {
        let userId = JSON.parse(info).id;
        userInfo({ user_id: userId }).then((user) => {
          if (user.code === 200) {
            store.setUserInfo(user.data);
            localStorage.setItem("userInfo", JSON.stringify(user.data));
          }
        });
      }
      if (res.code === 200) {
        data.writingList[data.writingList.length - 1].text = marked(
          res.data.answer
        );
        data.writingList[data.writingList.length - 1].copyText =
          res.data.answer;
        data.writingList[data.writingList.length - 1].flag = false;
        data.writingList[data.writingList.length - 2].flag = false;
        data.btnFlag = true;
        // let text = marked(res.data.answer)
        // let index = 0;
        // data.writingList[data.writingList.length-1].text = ''
        // data.time = setInterval(()=>{
        //   data.writingList[data.writingList.length-1].text += text.charAt(index);
        //   index++;
        //   if (index >= text.length) {
        //     data.btnFlag = true
        //     clearInterval(data.time)
        //   }
        //   nextTick(()=>{
        //     copywriting.value.scrollTop=9999999
        //   })
        // },100)
        store.copywritingFalse();
        document.documentElement.style.setProperty(
          "--textHeader",
          `${store.isSafari ? 120 : 50}px`
        );
      } else {
        //  if (res.code === 403) {
        //   data.writingList[data.writingList.length-1].text = res.data.message
        //     let text = res.data.message
        //     let index = 0;
        //     data.writingList[data.writingList.length-1].text = ''
        //     data.time = setInterval(()=>{
        //       data.writingList[data.writingList.length-1].text += text.charAt(index);
        //       index++;
        //       if (index >= text.length) {
        //         clearInterval(data.time)
        //       }
        //       nextTick(()=>{
        //         copywriting.value.scrollTop=9999999
        //       })
        //     },100)
        //  }

        data.edit(data.writingList[data.writingList.length - 2].text);
      }
    });
  } else {
    store.copywritingTrue();
  }
};

data.laud = () => {
  if (data.laudFlage) {
    data.laudFlage = false;
  } else {
    clickLike({ app_id: data.appInfo.id }).then((res) => {
      if (res.code === 200) {
        localStorage.setItem("laudFlae", false);
        data.localStorageFlage = false;
        data.laudFlage = true;
        showSuccessToast({
          message: res.message,
          icon: surres,
        });
      }
    });
  }
};

data.copy = async (e) => {
  const clipboard = new ClipboardJS(".copyBtn");
  clipboard.on("success", () => {
    showNotify({ type: "success", message: "复制成功" });
  });
  clipboard.on("error", () => {
    showNotify({ type: "danger", message: "复制失败" });
  });
};

data.itemType = (item) => {
  return item.type === "User";
};

data.textClick = (e) => {
  emit("editText", e);
  store.copywritingTrue();
};

data.swiperInit = () => {
  const swiper = new Swiper(".textSwiper", {
    slidesPerView: "auto",
    // spaceBetween: 60,
    longSwipes: true,
    simulateTouch: true, // 允许鼠标点击和拖动
    shortSwipes: true, // 设置短距离滑动有效
  });
  console.log(swiper);
  swiper.on("slideChange", function () {
    console.log(this.activeIndex);
    data.activeIndex = this.activeIndex;
  });
};
if (window.innerHeight <= 720) {
  data.innerHeightFlag = true;
}

onBeforeMount(() => {
  //console.log('2.组件挂载页面之前执行----onBeforeMount')
});
onMounted(() => {
  nextTick(() => {
    data.swiperInit();
  });
  if (data.userInfo && getToken()) {
    data.getHistoryDialogue(2);
  }
  //console.log('3.-组件挂载到页面之后执行-------onMounted')
});
watchEffect(() => {
  data.appInfo = JSON.parse(localStorage.getItem("appInfo"));
});
// 使用toRefs解构
// let { } = { ...toRefs(data) }
defineExpose({
  ...toRefs(data),
});
</script>
<style lang="scss" scoped>
.isSafariClass {
  height: calc(100vh - 420px);
}
.copywriting {
  height: calc(100vh - 360px - var(--textHeader));
  overflow: hidden;
  overflow-y: auto;
}
.copywriting::-webkit-scrollbar {
  display: none;
}
.main {
  min-height: calc(100vh - 360px - var(--textHeader));
  .center:last-of-type {
    padding-bottom: 90px;
  }
}
.item {
  margin-top: 40px;
  position: relative;
  display: flex;
  padding: 0 24px;
  .active {
    img {
      width: 88px;
      height: 88px;
      border-radius: 88px;
    }
    border-radius: 88px;
  }
  .text {
    align-self: flex-start;
    background: #323647;
    padding: 20px;
    width: calc(560 / 750 * 100vw);
    color: #ffffffff;
    font-size: 28px;
    font-weight: 300;
    border-radius: 24px;
    text-align: justify;
    margin-left: 16px;
    // white-space:pre-line;
    word-wrap: break-word;
  }
  .stop {
    display: flex;
    align-items: flex-end;
  }
  .copyBtn {
    position: absolute;
    bottom: 5px;
    right: 30px;
    width: 28px;
    height: 28px;
  }
}
.userItem {
  margin-top: 48px;
  display: flex;
  // flex-direction: row-reverse;
  padding: 0 24px;
  .active {
    img {
      width: 88px;
      height: 88px;
      border-radius: 88px;
    }
    border-radius: 88px;
  }
  .userEditBtn {
    display: flex;
    justify-content: flex-end;
    color: #ffffff;
    margin-top: 10px;
  }
  .text {
    align-self: flex-start;
    background: #8368fcff;
    padding: 20px;
    width: calc(560 / 750 * 100vw);
    color: #ffffffff;
    font-size: 28px;
    font-weight: 300;
    border-radius: 24px;
    margin-left: 16px;
    text-align: justify;
    white-space: pre-line;
    position: relative;
  }
  .editBtn {
    // position: absolute;
    bottom: -68px;
    right: 0;
    width: 120px;
    height: 58px;
    font-size: 28px;
    text-align: center;
    line-height: 58px;
    background: #323647;
    border-radius: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      margin-right: 8px;
      width: 32px;
      height: 32px;
    }
  }
}
.laud {
  margin-top: 20px;
  background: #1d2234;
  padding: 16px;
  color: #ffffff;
  margin-left: 128px;
  display: inline-block;
  border-radius: 20px;
  font-size: 26px;
  position: relative;
}
.laud::after {
  position: absolute;
  left: 32px;
  top: -10px;
  content: "";
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 10px solid #1d2234;
}
.btnList {
  margin-top: 12px;
  margin-left: 128px;
  color: #ffffff;
  font-size: 26px;
  display: flex;
  position: relative;
  .editBtn {
    margin-right: 20px;
    display: flex;
    align-items: center;
    background: #323647;
    border-radius: 16px;
    padding: 11px 16px;
    img {
      margin-right: 8px;
      width: 28px;
      height: 28px;
    }
  }
}
.m-t-134 {
  margin-top: 134px;
}
.down {
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #272934;
  height: 92px;
  line-height: 92px;
  box-shadow: 0px 0px 35px 0px rgba(0, 0, 0, 0.5);
  border-radius: 0px 0px 44px 44px;
}
.shares {
  width: 100%;
  height: 100%;
  // margin:0 24px;
  padding-bottom: 40px;
  .cavers {
    width: 702px;
    padding-bottom: 44px;
    background: url("~@/assets/shares.png") no-repeat;
    background-size: 232px 232px;
    background-position: top right;
    background-color: #daeefd;
    border-radius: 48px;
    margin-top: 107px;
    .header {
      padding: 0 32px;
      padding-top: 58px;
      // background-image: linear-gradient(
      //     182deg,
      //     rgba(71, 140, 247, 1) 0,
      //     rgba(131, 104, 252, 1) 100%
      //   );
      overflow-wrap: break-word;
      color: rgba(21, 60, 228, 1);
      font-size: 56px;
      font-family: MyCustomFont, sans-serif;
      text-align: justify;
      white-space: nowrap;
      line-height: 63px;
      margin-left: 2px;
      // -webkit-background-clip: text;
      // -webkit-text-fill-color: transparent;
    }
    .tip {
      padding: 0 32px;
      padding-top: 14px;
      font-size: 28px;
      font-weight: 400;
      color: #8368fc;
    }
    .sharsImg {
      padding: 28px;
      img {
        border-radius: 28px;
        width: 100%;
        height: 100%;
      }
    }
    .center {
      margin: 32px;
      padding: 28px;
      background: #ffffff;
      border-radius: 24px;
    }
    .item {
      margin-top: 32px;
      display: flex;
      .sharesActive {
        img {
          width: 88px;
          height: 88px;
        }
        border-radius: 288px;
      }
      .sharesText {
        margin-left: 16px;
        width: calc(100% - 122px);
        padding: 20px;
        border-radius: 24px;
        color: #8368fc;
        background: #e5dffe;
        font-size: 28px;
      }
      .mr-16 {
        margin-right: 16px;
        margin-left: 0px !important;
        display: flex;
        align-items: center;
      }
    }
    .item:first-child {
      margin-top: 0;
      .sharesText {
        color: #ffffff;
        line-height: 40px;
        background: #8368fc;
      }
    }
    .qrcode {
      margin: 32px;
      margin-top: 0;
      background: #ffffff;
      border-radius: 24px;
      padding: 30px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .title {
        font-weight: 500;
        color: #222222;
        font-size: 28px;
      }
      .samll {
        font-weight: 300;
        color: #666666;
        font-size: 24px;
      }
      .code {
        img {
          width: 110px;
          height: 110px;
        }
      }
    }
  }
  .bottom {
    color: #ffffff;
    font-size: 30px;
    display: flex;
    justify-content: space-around;
    // margin-right: 20px;
    margin-top: 36px;
    div {
      display: flex;
      align-items: center;
      background: #8368fc;
      border-radius: 24px;
      padding: 23px 28px;
    }
    img {
      width: 48px;
      height: 48px;
    }
  }
  .close {
    position: relative;
    text-align: center;
    margin-top: 33px;
    width: calc(100%);
    img {
      width: 44px;
      height: 44px;
    }
  }
}
.innerHeightClass {
  height: 300px;
}
.dotContainer {
  display: flex;
  margin-bottom: 2px;
}

.dot {
  margin: 0 5px;
  height: 7px;
  width: 7px;
  background-color: #ffffff;
  border-radius: 50%;
  animation: bounce 1s infinite;
}

.dot:nth-child(2) {
  animation-delay: 0.2s;
}

.dot:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes bounce {
  0%,
  100% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(-3px);
  }
}
</style>
<style>
* {
  margin: 0 0;
  padding: 0;
}
p {
  margin: 10px 0;
}
.popoverText {
  background: #1d2234;
  font-size: 26px;
  padding: 16px 20px;
  color: #ffffff;
}
:root {
  --van-notify-font-size: 24px !important;
  --van-popover-light-background: #1d2234 !important;
  --van-padding-md: 30px !important;
}
.refreshText {
  font-size: 28px;
  color: #f7f5ff60;
}
</style>
